<template>
  <div class="masonry-item" :style="styles">
    <slot></slot>
  </div>
</template>

<script>
import { getStyle } from '@/utils/utils';

export default {
  name: 'MasonryItem',
  props: {

  },
  inject: ['masonry'],
  data() {
    return {
      height: 0
    };
  },
  computed: {
    styles() {
      const style = {
        width: `${this.masonry.width}px`
      };

      return this.masonry.gutter === 0
        ? style
        : Object.assign(style, {
          padding: `${this.masonry.gutter / 2}px`
        });
    }
  },
  mounted() {
    this.height = parseInt(getStyle(this.$el, 'height'), 10);
    this.$parent.slotAdd(this.$el, this.height);
  },
  beforeDestroy() {
    this.$parent.slotDelete(this.$el, this.height);
  }
};
</script>
